import React, { Component } from 'react';

import './NossoAnoInvestimentos.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import { Pie } from 'react-chartjs-2';

import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	isEdge
} from '../../utils';

import {
	images
} from '../../settings';

import {
	DelayLink
} from '../../components/';

class NossoAnoInvestimentos extends Component {

	constructor() {
		super();

        this.images = images;

        this.colorSuperintendentes = (isEdge) ? '8,42,83' :  '#082A53';
        this.colorGerentes = (isEdge) ? '0,130,200' :  '#0082C8';
        this.colorCoordenadores = (isEdge) ? '51,173,183' :  '#33ADB7';
        this.colorAnalistas = (isEdge) ? '255,210,60' :  '#FFD23C';
        this.colorAssistentes = (isEdge) ? '251,155,1' :  '#FB9B01';
        this.colorApoios = (isEdge) ? '212,210,24' :  '#D4D218';
        this.colorEstagiarios = (isEdge) ? '124,183,46' :  '#7CB72E';
        this.colorJovensAprendizes = (isEdge) ? '38,136,48' :  '#268830';

        let colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes,
			colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes,
			colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores,
			colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas,
			colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes,
			colorApoios = (isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios,
			colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios,
			colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes;

        this.state = {
            borderWidth: 0,

			colorSuperintendentes: colorSuperintendentes,
			colorGerentes: colorGerentes,
			colorCoordenadores: colorCoordenadores,
			colorAnalistas: colorAnalistas,
			colorAssistentes: colorAssistentes,
			colorApoios: colorApoios,
			colorEstagiarios: colorEstagiarios,
			colorJovensAprendizes: colorJovensAprendizes,

            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeChartColor = this.changeChartColor.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}


    changeChartColor(area) {
    	let opacity = (isEdge) ? ',.2' : '15';

    	let colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+opacity+')' :  this.colorSuperintendentes + opacity;
    	let colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+opacity+')' :  this.colorGerentes + opacity;
    	let colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+opacity+')' :  this.colorCoordenadores + opacity;
    	let colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+opacity+')' :  this.colorAnalistas + opacity;
    	let colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+opacity+')' :  this.colorAssistentes + opacity;
    	let colorApoios = (isEdge) ? 'rgba('+this.colorApoios+opacity+')' :  this.colorApoios + opacity;
    	let colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+opacity+')' :  this.colorEstagiarios + opacity;
    	let colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+opacity+')' :  this.colorJovensAprendizes + opacity;

    	switch (area) {
    		case "superintendentes":
    			// colorSuperintendentes = this.colorSuperintendentes;
    			colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes;
    			break;

    		case "gerentes":
    			// colorGerentes = this.colorGerentes;
    			colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes;
    			break;

    		case "coordenadores":
    			colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores;
    			// colorCoordenadores = this.colorCoordenadores;
    			break;

    		case "analistas":
    			colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas;
    			// colorAnalistas = this.colorAnalistas;
    			break;

    		case "assistentes":
    			colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes;
    			// colorAssistentes = this.colorAssistentes;
    			break;

    		case "apoios":
    			colorApoios = (isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios;
    			// colorApoios = this.colorApoios;
    			break;

    		case "estagiarios":
    			colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios;
    			// colorEstagiarios = this.colorEstagiarios;
    			break;

    		case "jovens-aprendizes":
    			colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes;
    			// colorJovensAprendizes = this.colorJovensAprendizes;
    			break;

    		default:
    			colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes;
    			// colorSuperintendentes = this.colorSuperintendentes;
    			colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes;
    			// colorGerentes = this.colorGerentes;
    			colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores;
    			// colorCoordenadores = this.colorCoordenadores;
    			colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas;
    			// colorAnalistas = this.colorAnalistas;
    			colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes;
    			// colorAssistentes = this.colorAssistentes;
    			colorApoios = (isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios;
    			// colorApoios = this.colorApoios;
    			colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios;
    			// colorEstagiarios = this.colorEstagiarios;
    			colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes;
    			// colorJovensAprendizes = this.colorJovensAprendizes;
    			break;
    	}

		this.setState({
            colorSuperintendentes: colorSuperintendentes,
            colorGerentes: colorGerentes,
            colorCoordenadores: colorCoordenadores,
            colorAnalistas: colorAnalistas,
            colorAssistentes: colorAssistentes,
            colorApoios: colorApoios,
            colorEstagiarios: colorEstagiarios,
            colorJovensAprendizes: colorJovensAprendizes
		});
    }

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('7.3 Investimentos');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'nossoano-investimentos'
		];

		// Icon Columns - Assembleia
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

		const backgroundColor = [
			this.state.colorSuperintendentes,
			this.state.colorGerentes,
			this.state.colorCoordenadores,
			this.state.colorAnalistas,
			this.state.colorAssistentes,
			this.state.colorApoios,
			this.state.colorEstagiarios,
			this.state.colorJovensAprendizes,
		];

    	console.log('backgroundColor', backgroundColor);

		const labels = [
			'Superintendentes',
			'Gerentes',
			'Coordenadores',
			'Analistas',
			'Assistentes',
			'Apoios',
			'Estagiários',
			'Jovens aprendizes'
		];

		const labels2 = [
			'',
			'',
			'',
			'',
			'',
			'',
			'',
			''
		];

		const dataChart1 = {
			labels: labels2,
			datasets: [{
				data: [
					28,
					18,
					17,
					14,
					8,
					8,
					5,
					2
				],
				backgroundColor: backgroundColor,
				hoverBackgroundColor: backgroundColor,
				borderWidth: this.state.borderWidth
			}]
		};

		const legendOpts = {
			display: false
		};

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>7.3 Investimentos - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>7.3</span> Investimentos</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Nosso ano</p>
		        			</div>
		        		</header>
 
		        		<div className="views__content first__view row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half column--padding-right column--text">
					        			<p>
					        				O ano de 2018 foi marcado por mudanças nos nossos escritórios, com o objetivo de ganhar produtividade, gerar maior sinergia entre as equipes, reduzir custos fixos e melhorar a experiência dos associados em nossas instalações.
					        				<br /><br />
					        				Em agosto, após a transferência das áreas de negócios do Rio de Janeiro para São Paulo, o escritório mudou do centro do Rio para Botafogo. Com localização estratégica, o novo prédio fica próximo de boa parte dos associados, uma vez que há várias instituições no centro e no Leblon. 
					        			</p>
					        		</div>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.investimento_img1 } />
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content investimentos__view row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column">
					        			<p>
					        				Com dívida zero e 100% dos investimentos realizados com capital próprio, o plano de negócios garantiu que R$ 7 milhões fossem destinados ao <span onClick={ this.globalTransition }><DelayLink to="/nosso-ano/principais-iniciativas" delay={1000} className="beauty-a">ANBIMA Data</DelayLink></span> em 2018. O aporte representa 70% do investimento do ano. O projeto, que seguirá em 2019 e em 2020, tem custo estimado de R$ 24 milhões. Na sequência, aparecem as melhorias tecnológicas feitas no Selic como a aquisição de ferramentas para monitoramento das aplicações e a virtualização das estações de trabalho, representando 18% do orçamento. 
					        			</p>
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content investimentos__view--graficos row">
			        		<div className="container">
			        			<Fade bottom>
			        				<div className="graph_area">
			        					<img className="image image--base" src={ this.images.investimento_base } />

						        		<div className="side side--left">
			        						<img className="image" src={ this.images.investimento_homem } />

							        		<div className="data_list">
								        		<div className="data_list__item data_list__item--superintendentes"
									                onMouseEnter={ this.changeChartColor.bind(null, 'superintendentes') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>ANBIMA Data</span></div>
									        		<div className="item__number">28%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--gerentes"
									                onMouseEnter={ this.changeChartColor.bind(null, 'gerentes') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>Selic</span></div>
									        		<div className="item__number">18%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--coordenadores"
									                onMouseEnter={ this.changeChartColor.bind(null, 'coordenadores') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>TI</span></div>
									        		<div className="item__number">17%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--analistas"
									                onMouseEnter={ this.changeChartColor.bind(null, 'analistas') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>Institucional</span></div>
									        		<div className="item__number">14%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--assistentes"
									                onMouseEnter={ this.changeChartColor.bind(null, 'assistentes') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>Fóruns ANBIMA</span></div>
									        		<div className="item__number">8%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--apoios"
									                onMouseEnter={ this.changeChartColor.bind(null, 'apoios') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>Migração de datacenter</span></div>
									        		<div className="item__number">8%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--estagiarios"
									                onMouseEnter={ this.changeChartColor.bind(null, 'estagiarios') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>Novo cadastro</span></div>
									        		<div className="item__number">5%</div>
								        		</div>

								        		<div className="data_list__item data_list__item--jovens-aprendizes"
									                onMouseEnter={ this.changeChartColor.bind(null, 'jovens-aprendizes') }
									                onMouseLeave={ this.changeChartColor.bind(null, '') }>
									        		<div className="item__text"><span>Certificação</span></div>
									        		<div className="item__number">2%</div>
								        		</div>
						        			</div>

						        		</div>

						        		<div className="side side--right">
							        		<Fade left>
							        			<div className="chart">
							        				<Pie data={ dataChart1 } legend={ legendOpts } />
							        			</div>
							        		</Fade>
			        						<img className="image" src={ this.images.investimento_mulher } />
						        		</div>

			        				</div>
			        			</Fade>
		        			</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { NossoAnoInvestimentos };
